import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FavoritesService} from './favorites.service';
import {Element} from './element';

@Component({
    selector: 'favorites',      
    providers: [FavoritesService],      
    template: require('./favorites.component.html'),
})

export class SuperUserFavoritesComponent implements OnInit {

    router: Router;
    sellers: Element[];
    artisans: Element[];

    constructor(private _favoritesService: FavoritesService, _parentRouter: Router) {             
        this.router = _parentRouter;        
    }
    
    ngOnInit() {        
        this._favoritesService.getFavoritesSellersByUser().then(result => {
            this.sellers = result;
        });

        this._favoritesService.getFavoritesArtisansByUser().then(result => {
            this.artisans = result;
        });
    }

    backClicked() {
        window.history.back();
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/favorites/favorites.component.ts
 **/